export default "__VITE_ASSET__mY$RqfL6__"